<script>
  export let profile = null;
  import ContentPage from "./ContentPage.svelte";
  import HelpContent from "./Content/HelpContent.svelte";
</script>

<ContentPage profile="{profile}" title="Getting Help" content="{HelpContent}" />
